// First API Layer of claim module
import http, { expandURI } from '@/utils/ajax'
import { extractMenu, extractMessages } from '@/utils/extract'
// centralise all mutations
import {
  CLAIMS_CLAIMDETAIL_RESET,
  CLAIMS_INIT_LOADING,
  CLAIMS_INIT_SUCCESS,
  CLAIMS_INIT_FAIL,
  CLAIMS_REGISTER_INIT_LOADING,
  CLAIMS_REGISTER_INIT_SUCCESS,
  CLAIMS_REGISTER_INIT_FAIL,
  // CLAIMS_LISTING_INIT_LOADING,
  CLAIMS_LISTING_INIT_SUCCESS,
  CLAIMS_LISTING_INIT_FAIL,
  CLAIMS_CLAIMDETAIL_LOAD_DATA,
  CLAIMS_CLAIMDETAIL_INIT_LOADING,
  CLAIMS_CLAIMDETAIL_INIT_SUCCESS,
  CLAIMS_CLAIMDETAIL_INIT_FAIL,
  CLAIMS_PARAMS_SUCCESS,
  CLM_REN_MSG_INIT_LOADING,
  CLM_REN_MSG_INIT_SUCCESS,
  CLM_REN_MSG_INIT_FAIL,
  CLAIMS_LOAD_BACK_LISTING
} from '@/store/types'

export const general = {
  async claimsInit({ commit, rootState }) {
    const apiUrl = rootState.app.menu.claimsManagement
    if (apiUrl) {
      commit(CLAIMS_INIT_LOADING)
      try {
        const result = await http.get(apiUrl)
        const menu = extractMenu(result.data._links)
        const commitResult = {
          menu: menu
        }
        commit(CLAIMS_INIT_SUCCESS, commitResult)
      } catch (error) {
        commit(CLAIMS_INIT_FAIL, extractMessages(error))
      }
    } else {
      commit(CLAIMS_INIT_FAIL, extractMessages(['The request failed because it is trying to execute an invalid API url.']))
    }
  },
  async claimsRegisterInit({ commit, state }) {
    const apiUrl = state.menu.claimsRegister
    if (apiUrl) {
      commit(CLAIMS_REGISTER_INIT_LOADING)
      try {
        const result = await http.get(apiUrl)
        const menu = extractMenu(result.data._links)
        const commitResult = result.data
        Object.assign(commitResult, {
          menu: menu
        })
        commit(CLAIMS_REGISTER_INIT_SUCCESS, commitResult)
      } catch (error) {
        commit(CLAIMS_REGISTER_INIT_FAIL, extractMessages(error))
      }
    } else {
      commit(CLAIMS_REGISTER_INIT_FAIL, ['The request failed because it is trying to execute an invalid API url.'])
    }
  },
  async claimsListingInit({ commit, state }) {
    // reset claim state (prevent dirty data)
    commit(CLAIMS_CLAIMDETAIL_RESET)
    const apiUrl = state.menu.claimsListing
    if (apiUrl) {
      // commit(CLAIMS_LISTING_INIT_LOADING)
      try {
        const result = await http.get(apiUrl)
        const menu = extractMenu(result.data._links)
        const commitResult = result.data
        Object.assign(commitResult, {
          menu: menu
        })
        commit(CLAIMS_LISTING_INIT_SUCCESS, commitResult)
      } catch (error) {
        commit(CLAIMS_LISTING_INIT_FAIL, extractMessages(error))
      }
    } else {
      commit(CLAIMS_LISTING_INIT_FAIL, ['The request failed because it is trying to execute an invalid API url.'])
    }
  },
  async claimEntryInit({ commit, state }) {
    let apiUrl = state.claimRegister.menu.claimEntry
    if (apiUrl) {
      commit(CLAIMS_CLAIMDETAIL_INIT_LOADING)
      try {
        const expand = {
          clmNo: state.claimDetail.commonInfo.clmNo,
          busCls: state.claimDetail.commonInfo.busCls,
          branch: state.claimDetail.commonInfo.branch,
          dri: state.claimDetail.commonInfo.dri
        }
        const result = await http.get(expandURI(apiUrl, expand))
        const menu = extractMenu(result.data._links)
        const commitResult = result.data
        Object.assign(commitResult, {
          menu: menu
        })
        commit(CLAIMS_CLAIMDETAIL_INIT_SUCCESS, commitResult)
        if (commitResult) {
          // param listing if any
          commit(CLAIMS_PARAMS_SUCCESS, commitResult.data)
        }
      } catch (error) {
        // console.log(error)
        commit(CLAIMS_CLAIMDETAIL_INIT_FAIL, error)
      }
    } else {
      commit(CLAIMS_CLAIMDETAIL_INIT_FAIL, ['The request failed because it is trying to execute an invalid API url.'])
    }
  },
  async loadClaim({ commit, state }, data) {
    if (state.claimListing.menu.getClaim && data.clmNo) {
      try {
        const expand = {
          clmNo: data.clmNo
        }
        const result = await http.get(expandURI(state.claimListing.menu.getClaim, expand))
        if (result.data) {
          // const menu = extractMenu(result.data._links)
          // data.query: to defined if its coming from query (some stuff for query are not defaulted)
          const commitResult = {
            partialSave: false,
            data: result.data,
            query: data.query,
            remove: data.remove
          }
          commit(CLAIMS_CLAIMDETAIL_LOAD_DATA, commitResult)
        } else {
          throw new Error('Invalid Fetch Result')
        }
      } catch (err) {
        throw err
      }
    } else {
      throw new Error('The request failed because it is trying to execute an invalid API url.')
    }
  },
  async loadBack({ commit, state }, data) {
    if (data) {
      commit(CLAIMS_LOAD_BACK_LISTING, data)
    }
  },
  async clmRenMsgInit({ commit, state }) {
    const apiUrl = state.menu.renewalMessage
    if (apiUrl) {
      commit(CLM_REN_MSG_INIT_LOADING)
      try {
        const result = await http.get(apiUrl)
        const menu = extractMenu(result.data._links)
        const commitResult = result.data
        Object.assign(commitResult, {
          menu: menu
        })
        commit(CLM_REN_MSG_INIT_SUCCESS, commitResult)
      } catch (error) {
        commit(CLM_REN_MSG_INIT_FAIL, extractMessages(error))
      }
    } else {
      commit(CLM_REN_MSG_INIT_FAIL, ['The request failed because it is trying to execute an invalid API url.'])
    }
  }
}
